import 'containers/SmWorkbench/ProjectDetail/Show/Detail/Bottom/ConfirmQuote/index.less';
import * as React from 'react';
import PropTypes from 'prop-types';
import { Button, Table, InputNumber, Form, Upload, Select, Input } from '@beehive/components';
import { Checkbox, Button as BCButton, Space } from "@bedrock/components";
import { TabContent } from 'containers/SmWorkbench/ProjectDetail/Show/Detail/Bottom/components';
import { isBlank, showAlert, beforeUploadSuccess } from 'utils';
import classnames from 'classnames';
import { financial } from 'utils/number';
import _ from 'lodash';
import messages from 'messages/Workbench/ProjectDetail';
import { getCooperateAccountsQuoteData, getTranslatedFormItem } from 'containers/SmWorkbench/ProjectDetail/utils';
import { UploadFile } from 'modules/types/commons/file';
import { getAttachementUploadUrl } from 'containers/OutWorkbench/utils';
import { hasGrayConfigWithoutGroup } from 'utils/gray';
import { isAdsXiaohao } from '../PendingQuote/utils';
import NewPendingQuote from '@mpc/common/src/features/NewPendingQuote';
import StatementModal from 'containers/OutWorkbench/components/StatementModal';
import { tableColumnWidthToRem } from '@mpc/common/src/utils';

export interface ConfirmQuoteProps {
  tabKey: string;
}

const TABLE_COLUMNS = [
  { key: 'index', title: 'index', align: 'left', width: 120 },
  { key: 'platform', title: 'superior_resource_id', align: 'left' },
  { key: 'account', title: 'account', align: 'left' },
  { key: 'remark', title: 'remark', align: 'left' },
  { key: 'quote_price', title: 'quote_price_rmb', align: 'left', width: 164 },
  { key: 'currency', title: 'currency', align: 'left', width: 164 },
];

const FULL_COL_PROPS = {
  itemColProps: { span: 24 },
  itemLabelColProps: { span: 5 },
  itemInputColProps: { span: 16 },
};
export const FORM_PROPS = {
  mode: 'edit',
  isLabelVertical: false,
  showClientError: false,
  checkMinHeight: false,
  ...FULL_COL_PROPS,
};
const FORM_ITEMS = [
  {
    key: 'bid_attachs_blob_ids',
    label: 'bid_attachs',
    childProps: {
      type: 'Upload',
      uploadKey: 'bid_attachs',
      showUploadList: { showRemoveIcon: true },
      multiple: true,
      uploadTips: 'uploadTips',
    },
  },
];
const MAX_SIZE_LIMIT = 1024 * 1024 * 200;

class ConfirmQuote extends React.Component<ConfirmQuoteProps, any> {
  private quoteRef: React.RefObject<any> = React.createRef();
  public static contextTypes = {
    intl: PropTypes.object,
    prefixCls: PropTypes.string,
    menuKey: PropTypes.string,
    detail: PropTypes.any,

    loadDetail: PropTypes.func,
    projectMove: PropTypes.func,
  };

  currencyOptions = [];

  constructor(props: ConfirmQuoteProps, context: any) {
    super(props, context);
    const { intl, detail } = context;
    const form = getCooperateAccountsQuoteData(detail, intl, messages);
    // 后端返回货币枚举值
    this.currencyOptions = detail.options.quote_currencies;
    const fileList = this.getFileList();
    const attach = !!fileList ?
      fileList.reduce((prev: any, cur: any) => {
        // tslint:disable-next-line: variable-name
        const { uid: blob_id, key: blob_key } = cur;
        prev.push({ blob_id, blob_key });
        return prev;
      }, []) : [];
    this.state = { form, attachs: attach, submitting: false, isSelected: false, visible: false };
  }

  private handleSubmit = async () => {
    const { intl, menuKey, detail, loadDetail, projectMove } = this.context;
    const { form = [], attachs = [], newPendingQuoteParams = {}, isSelected } = this.state;
    const adsXiaohao = isAdsXiaohao(detail);
    const params = form
      .filter((i: any) => !i.isTotal)
      .filter((i: any) => {
        if (adsXiaohao) {
          return !isBlank(i.program_desc);
        } else {
          return !isBlank(i.quote_price);
        }
      });

    if (params.length <= 0) {
      showAlert({ type: 'error', message: intl.formatMessage(messages.hasNoQuoteAlert) });
      return;
    }

    if (!isSelected) {
      this.setState({ visible: true })
      return
    }
    const hasNotSameCurrency = form.some((item: any) => {
      return !item.isTotal && item.currency !== form[0].currency;
    });

    if (!adsXiaohao && hasNotSameCurrency) {
      showAlert({ type: 'error', message: '报价币种需要保持一致' });
      return;
    }

    let submitBody: any = {
      id: detail.id,
      [detail.state]: {
        is_pass: true,
        demand_suppliers_attributes: {
          id: detail.current_demand_supplier_id,
          is_quoted: true,
          demand_supplier_quotes_attributes: params.map((i: any) => {
            const item: any = {
              id: i.quote_id,
              cooperate_account_id: i.id,
            };
            if (adsXiaohao) {
              item.program_desc = i.program_desc;
            } else {
              item.quote_price = i.quote_price;
              item.currency = i.currency;
            }
            return item;
          }),
          bid_attachs_blob_ids: [...attachs],
        },
      },
      type: 'save',
    };

    if (hasGrayConfigWithoutGroup(['external.demand_flow.pending_quote'])) {
      const data = await this.quoteRef.current?.validateFields()
      const bid_attachs_blob_keys = data?.bid_attachs?.map((item: any) => item.blob?.key)
      const merge_quote_attach_blob_keys = detail?.quote_upload_method === 'MULTI_UPLOAD' ? 
       data?.merge_quote_attachs?.map((item: any) => item.blob?.blob_key || item.blob?.key) : undefined;      
      if (detail?.structured) {
        submitBody = {
          id: detail.id,
          state: detail.state,
          pass: true,
          form: {
            id: detail.id,
            demand_supplier: {
              ...newPendingQuoteParams,
              demand_supplier_quotes: newPendingQuoteParams?.demand_supplier_quotes?.filter((item: any) => item.ableQuote)?.map(v => {
                return {
                  ...v,
                  necessary_rights: v?.cooperate_account?.necessary_rights,
                  expect_rights: v?.cooperate_account?.expect_rights,
                }
              }) || [],
              is_quoted: true,
              id: detail.current_demand_supplier_id,
              bid_attachs_blob_keys,
              merge_quote_attach_blob_keys,
            }
          },
        };
      } else {
        submitBody = {
          id: detail.id,
          state: detail.state,
          pass: true,
          type: 'save',
          form: {
            id: detail.id,
            demand_supplier: {
              id: detail.current_demand_supplier_id,
              is_quoted: true,
              demand_supplier_quotes: params.map((i: any) => {
                const item: any = {
                  id: i.quote_id,
                  cooperate_account_id: i.id,
                };
                if (adsXiaohao) {
                  item.program_desc = i.program_desc;
                } else {
                  item.quote_price = i.quote_price;
                  item.currency = i.currency;
                }
                return item;
              }),
              bid_attachs_blob_keys: attachs.map((a: any) => a.blob_key),
            },
          },
        };
      }
    }

    this.setState({ submitting: true });
    return projectMove(submitBody, { menuKey, grayKey: 'pending_quote' })
      .then((res: any) => {
        showAlert({ type: 'success', message: res.res_msg });
        this.setState({ submitting: false });
        loadDetail();
      })
      .catch((error: any) => {
        showAlert({
          type: 'error',
          message: typeof error === 'string' ? error : error.message,
        });
        this.setState({ submitting: false });
      });
  }

  private getTotalPrice = (data: any[]) => {
    const total = data.filter((i: any) => !i.isTotal)
      .reduce((prev: number, curr: any) => {
        const price = curr['quote_price'];
        prev = _.add(prev, isBlank(price) ? 0 : +price);
        return prev;
      }, 0);
    return total;
  }

  private handleBeforeUpload = (file: any) => {
    const { intl } = this.context;
    if (file.size && file.size > MAX_SIZE_LIMIT) {
      showAlert({
        type: 'error', message: intl.formatMessage(messages.fileExceededLimit, {
          filename: file.name,
          fileMaxSize: '200M',
        }),
      });
      return false;
    }
    return true;
  }

  private getUploadBody = (file: UploadFile, key: string) => {
    return {
      model: 'SocialMedia::ProjectSupplier',
      filename: file.name,
      attach_type: key,
    };
  }

  private handleUploadChange = (options: any, key: string) => {
    const { attachs = [] } = this.state;
    const { file } = options;
    const blob = _.get(file, 'response.data');
    const { uid } = file;
    let newAttaches = [...attachs];
    switch (file.status) {
      case 'done':
        newAttaches.push({ blob_id: blob.blob_id, blob_key: blob.blob_key });
        break;
      case 'removed':
        newAttaches = !!blob
          ? newAttaches.filter((a: any) => a.blob_id !== blob.blob_id)
          : newAttaches.filter((a: any) => a.blob_id !== uid);
        break;
      default:
        return;
    }
    this.setState({ attachs: newAttaches });
  }

  private handleChange = (key: string, index: number, value: any) => {
    const { form = [] } = this.state;
    const newForm = [...form];
    if (key === 'currency') {
      newForm.forEach((item) => {
        if (!item.isTotal) {
          item[key] = value;
        }
      });
    } else {
      newForm[index][key] = value;
    }
    const totalItem = newForm.find((item) => !!item.isTotal);
    if (totalItem) {
      totalItem['quote_price'] = this.getTotalPrice(newForm);
    }
    this.setState({ form: newForm });
  }

  private getColumnDefaultRender = () => {
    return (v: any, r: any, i: number) => {
      return isBlank(v) ? r.isTotal ? '' : '--' : v;
    };
  }

  private getFileList = () => {
    const { detail: { project_suppliers = [] } } = this.context;
    let bidAttachs = [];
    if (project_suppliers.length > 0) {
      const { bid_attachs } = project_suppliers[0];
      if (bid_attachs.length === 0) {
        return;
      } else {
        bidAttachs = bid_attachs;
      }
    }
    const attach = bidAttachs.reduce((prev: any, cur: any) => {
      const { blob } = cur;
      if (!!blob) {
        const { id: uid, filename: name, byte_size: size, key } = blob;
        prev.push({ uid, name, size, key });
        return prev;
      }
    }, []);
    return attach;
  }

  private renderFormItemChild = (itemProps: any, childProps: any) => {
    const { key } = itemProps;
    const { type, ...childPropsRest } = childProps;
    const hasAttch = this.getFileList() || undefined;
    switch (type) {
      case 'Upload': {
        const { uploadKey, ...uploadPropsRest } = childPropsRest;
        return (
          <Upload
            {...uploadPropsRest}
            action={getAttachementUploadUrl()}
            beforeUpload={this.handleBeforeUpload}
            defaultFileList={!!hasAttch ? this.getFileList() : []}
            beforeSuccess={beforeUploadSuccess}
            data={(file: UploadFile) => this.getUploadBody(file, uploadKey)}
            onChange={(options: any) => this.handleUploadChange(options, key)}
          />
        );
      }
      default: {
        return <span />;
      }
    }
  }

  private getColumnRender = () => {
    const { intl, detail } = this.context;
    return {
      index: (v: any, r: any, i: number) => {
        return r.isTotal ? intl.formatMessage(messages.quote_price_total) : isBlank(v) ? '--' : v;
      },
      quote_price: (v: any, r: any, i: number) => {
        if (r.isTotal) {
          return isBlank(v) ? '--' : financial(v);
        }
        return (
          <InputNumber
            hideHandle
            min={0}
            precision={2}
            disabled={!detail.can_modify}
            placeholder={intl.formatMessage(messages.inputPlaceholder)}
            value={v}
            formatter={(val: any) => financial(val, true)}
            onChange={(value: any) => this.handleChange('quote_price', i, value)}
          />
        );
      },
      currency: (v: any, r: any, i: number) => {
        if (r.isTotal) {
          return '';
        }
        return (
          <Select
            mode="select"
            style={{ width: 120 }}
            options={this.currencyOptions}
            popupProps={{ getPopupContainer: undefined }}
            value={v}
            onChange={(value: any) => this.handleChange('currency', i, value)}
          />
        );
      },
      program_desc: (v: any, r: any, i: number) => {
        if (r.isTotal) {
          return '';
        }
        return (
          <Input.TextArea
            maxHeight={71}
            minHeight={32}
            maxLength={500}
            autosize
            value={v}
            onChange={(e: any) => this.handleChange('program_desc', i, e.target.value)}
          />
        );
      },
    };
  }

  private getColumns = () => {
    const { intl, detail } = this.context;
    const defaultRender = this.getColumnDefaultRender();
    const columRenders = this.getColumnRender();

    let columns = TABLE_COLUMNS;
    if (isAdsXiaohao(detail)) {
      columns = columns
        .filter((v: any) => !['quote_price', 'currency'].includes(v.key))
        .map((v: any) => ({
          ...v,
          width: undefined,
        }));
      columns.push({
        key: 'program_desc',
        title: 'program_desc',
        align: 'left',
      });
    }
    return columns.map((item: any) => {
      return {
        ...tableColumnWidthToRem(item),
        dataIndex: item.key,
        title: intl.formatMessage(messages[item.title]),
        render: columRenders[item.key] || defaultRender,
        className: classnames({
          [item.key]: true,
        }),
      };
    });
  }

  private handleCheckBoxChange = (isSelected: boolean) => {
    this.setState({ isSelected })
  }
  private handleOpenModal = () => {
    this.setState({ visible: true })
  }

  private renderBottom = () => {
    const { intl } = this.context;
    const { submitting, isSelected } = this.state;
    return (
      <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: 20 }}>
        <Space size={4}>
          <Checkbox checked={isSelected} onChange={e => {
            this.handleCheckBoxChange(e.target.checked)
          }}>
            我已阅读并同意
          </Checkbox>
          <BCButton type='link' onClick={this.handleOpenModal}>《报价声明》</BCButton>
        </Space>
        <Button
          className="pull-right"
          size="large"
          type="primary"
          loading={submitting}
          onClick={this.handleSubmit}
        >
          {intl.formatMessage(messages.submit)}
        </Button>
      </div>

    );
  }

  componentDidMount(): void {
    const { detail } = this.context;
    this.setState({ newPendingQuoteParams: detail?.demand_suppliers?.[0] })
  }


  public render() {
    const { intl, detail } = this.context;
    const { tabKey } = this.props;

    const { form, visible } = this.state;
    const bottom = this.renderBottom();
    const columns = this.getColumns();

    return (
      <TabContent tabKey={tabKey} bottom={bottom} canScroll>
        <>
          {detail?.structured ? <NewPendingQuote
            detail={detail}
            ref={this.quoteRef}
            value={this.state.newPendingQuoteParams}
            onChange={value => {
              this.setState({ newPendingQuoteParams: value })
            }}
          /> :
            <>
              <Table
                columns={columns}
                data={form}
                size="small"
                rowKey="index"
              />
              <Form {...FORM_PROPS}>
                {FORM_ITEMS.map((item: any) => {
                  const translatedItem = getTranslatedFormItem(item, intl, messages);
                  const { childProps, ...itemProps } = translatedItem;
                  return (
                    <Form.Item
                      {...itemProps}
                      key={itemProps.key}
                      itemKey={itemProps.formKey || itemProps.key}
                      className={itemProps.key}
                    >
                      {this.renderFormItemChild(itemProps, childProps)}
                    </Form.Item>
                  );
                })}
              </Form>
            </>
          }
        </>
        <StatementModal visible={visible} onCancel={() => {
          this.setState({ visible: false, isSelected: false })
        }} onOk={() => {
          this.setState({ visible: false, isSelected: true }, () => {
            this.handleSubmit()
          })
        }} />
      </TabContent>
    );
  }

}

export default ConfirmQuote;
